import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useMemo } from "react";
import { useLocale } from "next-intl";
import { getLocalizedPath } from "@/utils/pathUtils";
import { cdnCarPath } from "@/constants/cdnUrls";

function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}

export default function PopularCompaniesCard({ item, dataLayerPayload }) {
  const t = useTranslationDetector();
  const locale = useLocale();

  const handleClick = () => {
    if (dataLayerPayload) {
      pushCtaClickDataLayer(dataLayerPayload, item.Name);
    }
  };

  const href = useMemo(() => {
    const localizedPath = getLocalizedPath(`/car-rental/company/[slug]`, locale);

    return localizedPath.replace("[slug]", item.Slug);
  }, [locale, item]);

  return (
    <Link
      className="flex w-full flex-col items-center justify-center gap-3"
      href={href}
      title={t("Car.cityCarRental", { 0: item.Name })}
      onClick={handleClick}
    >
      <div className="flex items-center justify-center rounded-[10px] bg-[#F5F5F9] w-full h-[134px]">
        <figure className="bg-border-light-grey flex h-full w-full items-center justify-center rounded-[100%]">
          <Image
            src={`${cdnCarPath}/widget-logos/${item?.Slug}.svg`}
            width={0}
            height={0}
            className="grayscale filter w-full h-[52px] object-contain"
            alt={item.Name || item.Slug}
          />
        </figure>
      </div>
      <div className="text-base font-medium">{item.Name || 'Sixt'}</div>
    </Link>
  );
}
